import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { SportsThemedButtonDirective } from '@frontend/sports/common/ui/sports-themed-button';
import { OddsFormatterPipe } from '@frontend/sports/odds/feature';
import { DsButton } from '@frontend/ui/button';
import { DsCheckbox } from '@frontend/ui/checkbox';
import { EffectsModule } from '@ngrx/effects';
import { ArcModule } from 'packages/sports/web/app/src/arc/arc.module';
import { ShowInEpcotDirective } from 'packages/sports/web/app/src/common/epcot-config.directive';
import { EpcotNotificationComponent } from 'packages/sports/web/app/src/common/epcotNotifications/notification.component';
import { ItemComponent } from 'packages/sports/web/app/src/common/item/item.component';
import { HelpBoxBadgeComponent } from 'packages/sports/web/app/src/help-box/help-box-badge.component';
import { MarketSubtypeLogoComponent } from 'packages/sports/web/app/src/marketsubtype-logo/marketsubtype-logo.component';
import { NativeAlertsModule } from 'packages/sports/web/app/src/native-alerts/native-alerts.module';
import { PriceboostCountSignpostComponent } from 'packages/sports/web/app/src/shared-priceboost/Components/priceboost-count-signpost.component';

import BetslipBaseModule from '../../base/betslip-base.module';
import BetslipAlertsModule from '../alerts/alerts.module';
import { DigitalBalanceHeaderModule } from '../balance-header/digital-balance-header.module';
import { BetslipDigitalCommonModule } from '../common/digital-module';
import { LinearBetBuilderModule } from '../linear-bet-builder/linear-bet-builder.module';
import { LinearBetslipModule } from '../linear/linear-betslip-module';
import { BetslipOverAskDigitalModule } from '../over-ask/over-ask-digital.module';
import BetslipDigitalPicksModule from '../picks/betslip-digital-picks.module';
import PickOddsModule from '../picks/pick-odds.module';
import BetslipDigitalQuickLinksModule from '../quick-links/betslip-digital-quick-links.module';
import BetslipShareMyBetModule from '../share-my-bet/betslip-share-my-bet.module';
import BetslipDigitalStakeLimitModule from '../stake-limit/betslip-digital-stake-limit.module';
import BetslipDigitalTaxationModule from '../taxation/betslip-digital-taxation.module';
import { ResultFailedSlipsContainerComponent } from './components/digital/failed/result-failed-container.component';
import { ResultFailedSlipComponent } from './components/digital/failed/result-failed-slip.component';
import { LinearResultHeaderComponent } from './components/digital/linear/header/linear-result-header.component';
import { LinearResultBetBuilderComponent } from './components/digital/linear/linear-result-bet-builder.component';
import { LinearResultBetReturnsComponent } from './components/digital/linear/linear-result-bet-returns.component';
import { LinearResultComboComponent } from './components/digital/linear/linear-result-combo.component';
import { LinearResultLinksComponent } from './components/digital/linear/linear-result-links.component';
import { LinearResultModelHeaderComponent } from './components/digital/linear/linear-result-model-header.component';
import { LinearResultSingleComponent } from './components/digital/linear/linear-result-single.component';
import { LinearResultSlipsComponent } from './components/digital/linear/linear-result-slips.component';
import { LinearResultSystemWrapperComponent } from './components/digital/linear/linear-result-system-wrapper.component';
import { LinearResultSystemComponent } from './components/digital/linear/linear-result-system.component';
import { LinearResultComponent } from './components/digital/linear/linear-result.component';
import { ResultRewardsCtaComponent } from './components/digital/linear/rewards-cta/result-rewards-cta.component';
import { LinearResultSummaryComponent } from './components/digital/linear/summary/linear-result-summary.component';
import { ResultActionsComponent } from './components/digital/result-actions.component';
import { ResultHeaderComponent } from './components/digital/result-header.component';
import { ResultKeepPlacedComponent } from './components/digital/result-keep-placed.component';
import { ResultLinksComponent } from './components/digital/result-links.component';
import { ResultOddsComponent } from './components/digital/result-odds.component';
import { ResultRewardUsedBadgeComponent } from './components/digital/result-reward-used-badge.component';
import { ResultRewardUsedComponent } from './components/digital/result-reward-used.component';
import { ResultSlipsDetailsSwitcherComponent } from './components/digital/result-slips-details-switcher.component';
import { ResultSlipsComponent } from './components/digital/result-slips.component';
import { ResultSucceededPickListComponent } from './components/digital/result-succeeded-pick-list.component';
import { ResultSucceededPickteaserInfoComponent } from './components/digital/result-succeeded-pick-teaser-info.component';
import { ResultSucceededPickComponent } from './components/digital/result-succeeded-pick.component';
import { ResultSucceededSlipComponent } from './components/digital/result-succeeded-slip.component';
import { ResultSucceededTeaserSlipComponent } from './components/digital/result-succeeded-teaser-slip.component';
import { ResultSummaryComponent } from './components/digital/result-summary.component';
import { ResultTokenPayoutComponent } from './components/digital/result-token-payout-summary.component';
import { ResultComponent } from './components/digital/result.component';
import PlaceBetResultEffects from './effects/place-bet-result-effects';
import { BetslipResultConfiguration, BetslipResultConfigurationBase } from './services/result-configuration.service';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        BetslipAlertsModule,
        EffectsModule.forFeature([PlaceBetResultEffects]),
        BetslipBaseModule,
        BetslipDigitalCommonModule,
        BetslipShareMyBetModule,
        BetslipDigitalQuickLinksModule,
        AutomationModule,
        BetslipDigitalStakeLimitModule,
        BetslipDigitalTaxationModule,
        PickOddsModule,
        PriceboostCountSignpostComponent,
        ArcModule,
        NativeAlertsModule,
        BetslipOverAskDigitalModule,
        ShowInEpcotDirective,
        EpcotNotificationComponent,
        ItemComponent,
        LinearBetslipModule,
        HelpBoxBadgeComponent,
        MarketSubtypeLogoComponent,
        DsButton,
        DsCheckbox,
        SportsThemedButtonDirective,
        BetslipDigitalPicksModule,
        LinearBetBuilderModule,
        DigitalBalanceHeaderModule,
        OddsFormatterPipe,
        ResultRewardsCtaComponent,
    ],
    providers: [
        {
            provide: BetslipResultConfigurationBase,
            useClass: BetslipResultConfiguration,
        },
    ],
    declarations: [
        ResultComponent,
        ResultHeaderComponent,
        ResultSummaryComponent,
        ResultKeepPlacedComponent,
        ResultSlipsDetailsSwitcherComponent,
        ResultSlipsComponent,
        ResultSucceededSlipComponent,
        ResultSucceededTeaserSlipComponent,
        ResultFailedSlipComponent,
        ResultSucceededPickComponent,
        ResultSucceededPickListComponent,
        ResultActionsComponent,
        ResultLinksComponent,
        ResultFailedSlipsContainerComponent,
        ResultSucceededPickteaserInfoComponent,
        ResultOddsComponent,
        ResultTokenPayoutComponent,
        LinearResultComponent,
        LinearResultSlipsComponent,
        LinearResultSingleComponent,
        LinearResultBetBuilderComponent,
        LinearResultComboComponent,
        LinearResultBetReturnsComponent,
        LinearResultSummaryComponent,
        LinearResultHeaderComponent,
        LinearResultModelHeaderComponent,
        LinearResultLinksComponent,
        LinearResultSystemComponent,
        LinearResultSystemWrapperComponent,
        ResultRewardUsedComponent,
        ResultRewardUsedBadgeComponent,
    ],
    exports: [
        ResultComponent,
        LinearResultComponent,
        ResultSummaryComponent,
        ResultOddsComponent,
        ResultKeepPlacedComponent,
        ResultSucceededSlipComponent,
        LinearResultSlipsComponent,
    ],
})
export default class BetslipDigitalResultModule {}
